import axios from 'axios'
import { memo } from 'react'
import { torrentsHost, viewedHost } from 'utils/Hosts'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import { SmallLabel, MainSectionButtonGroup } from './style'

const TorrentFunctions = memo(({ hash, locked, name, title, setViewedFileList }) => {
  const { t } = useTranslation()
  const dropTorrent = () => axios.post(torrentsHost(), { action: 'drop', hash })
  const removeTorrentViews = () =>
    axios.post(viewedHost(), { action: 'rem', hash, file_index: -1 }).then(() => setViewedFileList())
  const magnet = `magnet:?xt=urn:btih:${hash}&dn=${encodeURIComponent(name || title)}`

  return (
    <>
      <SmallLabel mb={10}>{t('TorrentState')}</SmallLabel>
      <MainSectionButtonGroup>
        <Button onClick={() => removeTorrentViews()} variant='contained' color='primary' size='large'>
          {t('RemoveViews')}
        </Button>
        <Button
          disabled={locked}
          title={locked ? t('UnlockTorrentFirst') : t('DropTorrent')}
          onClick={() => dropTorrent()}
          variant='contained'
          color='primary'
          size='large'
        >
          {t('DropTorrent')}
        </Button>
      </MainSectionButtonGroup>
      <SmallLabel mb={10}>{t('Info')}</SmallLabel>
      <MainSectionButtonGroup>
        <CopyToClipboard text={magnet}>
          <Button variant='contained' color='primary' size='large'>
            {t('CopyHash')}
          </Button>
        </CopyToClipboard>
      </MainSectionButtonGroup>
    </>
  )
})

export default TorrentFunctions
